import { Box, Stack, type ButtonOwnProps, Typography } from '@mui/material';
import type { PropsWithChildren, ReactNode } from 'react';

import { Loader } from '@/components/shared/loader';

import { ButtonWithIcon } from '../buttons/buttonWithIcon';

interface ButtonProps {
  text: string;
  onClick: () => Promise<void> | void;
  disabled?: boolean;
  disabledTooltip?: string;
  variant?: ButtonOwnProps['variant'];
  'data-testid': string;
  icon?: string | ReactNode;
  iconPosition?: 'left' | 'right';
}

export interface PanelFooterProps extends PropsWithChildren {
  primaryButton: ButtonProps;
  secondaryButton?: ButtonProps;
  submitInProgress?: boolean;
  loadingText?: string;
  hideButtons?: boolean;
}

export const PanelFooter = (props: PanelFooterProps) => {
  const {
    primaryButton,
    secondaryButton,
    children,
    submitInProgress,
    loadingText,
    hideButtons,
  } = props;

  return (
    <Stack
      direction='row'
      sx={{
        gap: '40px',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingX: '40px',
        paddingY: '16px',
        boxShadow: 'var(--mui-customShadows-panelMd)',
      }}
    >
      <Box
        sx={{
          flexGrow: 1,
        }}
      >
        {children}
      </Box>
      <Stack
        direction='row'
        sx={{
          gap: '12px',
          alignItems: 'center',
        }}
      >
        {submitInProgress && (
          <>
            <Loader size='medium' />
            <Typography>{loadingText || 'Loading...'}</Typography>
          </>
        )}
        {!submitInProgress && !hideButtons && (
          <>
            {secondaryButton && (
              <ButtonWithIcon
                {...secondaryButton}
                variant={secondaryButton.variant || 'text'}
              />
            )}
            <ButtonWithIcon
              {...primaryButton}
              variant={primaryButton.variant || 'contained'}
            />
          </>
        )}
      </Stack>
    </Stack>
  );
};
